"use client"
import { AnimatePresence, motion } from "motion/react"

export default ({ open, children, close = () => {} }) => {
    return (
        <>
            <AnimatePresence>
                {open && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.25 }}
                        className="fixed bg-caviar/75 z-80 inset-0 min-h-screen h-screen w-full p-10 flex md:block"
                        onClick={() => close()}
                    >
                        <div className="m-auto w-full h-full md:z-90 md:absolute md:left-1/2 md:top-1/2 md:w-3/4 md:h-3/4 md:flex md:-translate-1/2">
                            {children}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    )
}
